<template>
    <div class="mobile-capsule tw-flex tw-flex-col tw-items-center">
        <div
            class="mobile-capsule-item tw-flex tw-flex-col tw-items-center"
            @click="
                () => {
                    phoneModalVisible = true
                }
            "
        >
            <img
                class="tw-w-[0.32rem] tw-h-[0.32rem] tw-mb-[0.18rem]"
                :src="getOSSUrl('glb/icon/layout-capsule-phone.png')"
            />
            <span>电话咨询</span>
        </div>
        <div
            class="mobile-capsule-item tw-flex tw-flex-col tw-items-center"
            @click="
                () => {
                    wechatModalVisible = true
                }
            "
        >
            <img
                class="tw-w-[0.46rem] tw-h-[0.38rem] tw-mb-[0.18rem]"
                :src="getOSSUrl('glb/icon/layout-capsule-wechat.png')"
            />
            <span>微信客服</span>
        </div>
        <!-- 咨询热线 -->
        <FullScreenModal
            :visible="phoneModalVisible"
            @update:visible="val => (phoneModalVisible = val)"
        >
            <template #content>
                <div class="tw-w-full tw-flex tw-justify-center tw-items-center">
                    <div class="consulting-hotline tw-pt-[0.12rem] tw-pb-[0.32rem]">
                        <p
                            class="tw-text-[0.36rem] tw-text-[#1a1a1a] tw-leading-none tw-mb-[0.28rem]"
                        >
                            咨询热线：
                        </p>
                        <p class="tw-text-[0.72rem] tw-text-[#1a1a1a] tw-leading-none">
                            400-029-9007
                        </p>
                    </div>
                </div>
            </template>
        </FullScreenModal>
        <!-- 微信客服 -->
        <FullScreenModal
            :visible="wechatModalVisible"
            @update:visible="val => (wechatModalVisible = val)"
        >
            <template #content>
                <div class="tw-w-full tw-flex tw-justify-center tw-items-center">
                    <div class="customer-service tw-pt-[0.12rem] tw-flex">
                        <div class="tw-flex tw-flex-col tw-items-center tw-pr-[0.46rem]">
                            <div
                                class="tw-w-[2.14rem] tw-h-[2.14rem] tw-mb-[0.32rem] tw-p-[0.14rem] tw-bg-[#e6f4ff] tw-rounded-[0.06rem]"
                            >
                                <img
                                    class="tw-w-full tw-h-full"
                                    :src="getOSSUrl('glb/icon/wechat-official-accounts.png')"
                                />
                            </div>
                            <span class="tw-text-[0.28rem] tw-text-[#1a1a1a] tw-leading-none">
                                咨询顾问
                            </span>
                        </div>
                        <div class="tw-flex tw-flex-col tw-items-center">
                            <div
                                class="tw-w-[2.14rem] tw-h-[2.14rem] tw-mb-[0.32rem] tw-p-[0.14rem] tw-bg-[#e6f4ff] tw-rounded-[0.06rem]"
                            >
                                <img
                                    class="tw-w-full tw-h-full"
                                    :src="getOSSUrl('glb/icon/wechat-service.jpg')"
                                />
                            </div>
                            <span class="tw-text-[0.28rem] tw-text-[#1a1a1a] tw-leading-none">
                                关注公众号
                            </span>
                        </div>
                    </div>
                </div>
            </template>
        </FullScreenModal>
    </div>
</template>

<script>
import { getOSSUrl } from '@/utils/index.js'
import FullScreenModal from './FullScreenModal.vue'

export default {
    name: 'MobileCapsule',
    components: {
        FullScreenModal,
    },
    data() {
        return {
            phoneModalVisible: false,
            wechatModalVisible: false,
        }
    },
    methods: {
        getOSSUrl,
    },
}
</script>

<style lang="less">
.mobile-capsule {
    color: #1a1a1a;
    font-size: 0.2rem;
    background-color: rgba(255, 255, 255, 0.98);
    width: 1.06rem;
    padding: 0.52rem 0;
    border-radius: 0.54rem;
    box-shadow: 0 3px 6px 1px rgba(174, 174, 174, 0.16);
    position: fixed;
    right: 0.2rem;
    bottom: 1.7rem;
    z-index: 99;

    > div + div {
        margin-top: 0.46rem;
    }
}
</style>
